import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, Menu, X, Sparkles } from "lucide-react";
import AuthModal from "@/components/AuthModal";
import Logo from "@/components/Logo";

export default function HeaderNav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [open, setOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState("signup");

  const openAuth = (mode) => { setAuthMode(mode); setAuthOpen(true); };

  return (
    <>
      <header className="sticky top-0 z-40 backdrop-blur-md bg-[rgba(251,249,245,0.85)] border-b border-[var(--border-warm)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="nav-logo">
            <Logo size={30}/>
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            <Link to="/gigs" className="text-sm font-medium hover:text-[var(--copper)] transition flex items-center gap-1.5" data-testid="nav-gigs">
              <span className="w-1.5 h-1.5 rounded-full bg-[var(--copper)] animate-pulse"></span>
              Live gigs
            </Link>
            <Link to="/app" className="text-sm font-medium hover:text-[var(--copper)] transition" data-testid="nav-directory">Directory</Link>
            <Link to="/app?tab=community" className="text-sm font-medium hover:text-[var(--copper)] transition" data-testid="nav-community">Community</Link>
            <Link to="/pricing" className="text-sm font-medium hover:text-[var(--copper)] transition" data-testid="nav-pricing">Pricing</Link>
          </nav>

          <div className="hidden md:flex items-center gap-3">
            {user ? (
              <>
                {user.pro && (
                  <span className="tag-pill" style={{background:"var(--forest)", color:"var(--alabaster)", border:"none"}}>
                    <Sparkles size={12}/> Pro
                  </span>
                )}
                <span className="text-sm font-medium" data-testid="nav-user-name">{user.name}</span>
                <button onClick={()=>{logout(); nav("/");}} className="btn-outline !py-2 !px-3" data-testid="nav-logout-btn">
                  <LogOut size={14}/>
                </button>
              </>
            ) : (
              <>
                <button onClick={()=>openAuth("login")} className="text-sm font-semibold" data-testid="nav-login-btn">Log in</button>
                <button onClick={()=>openAuth("signup")} className="btn-primary" data-testid="nav-signup-btn">Start free</button>
              </>
            )}
          </div>

          <button className="md:hidden" onClick={()=>setOpen(!open)} data-testid="nav-menu-btn">
            {open ? <X/> : <Menu/>}
          </button>
        </div>

        {open && (
          <div className="md:hidden border-t border-[var(--border-warm)] bg-[var(--alabaster)] px-6 py-4 space-y-3">
            <Link to="/gigs" onClick={()=>setOpen(false)} className="block font-medium">Live gigs</Link>
            <Link to="/app" onClick={()=>setOpen(false)} className="block font-medium">Directory</Link>
            <Link to="/app?tab=community" onClick={()=>setOpen(false)} className="block font-medium">Community</Link>
            <Link to="/pricing" onClick={()=>setOpen(false)} className="block font-medium">Pricing</Link>
            {user ? (
              <button onClick={()=>{logout(); nav("/"); setOpen(false);}} className="btn-outline w-full">Log out</button>
            ) : (
              <div className="flex gap-2">
                <button onClick={()=>{openAuth("login"); setOpen(false);}} className="btn-outline flex-1">Log in</button>
                <button onClick={()=>{openAuth("signup"); setOpen(false);}} className="btn-primary flex-1">Start free</button>
              </div>
            )}
          </div>
        )}
      </header>
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} initialMode={authMode} onSuccess={()=>{
        setAuthOpen(false);
        if (loc.pathname === "/") nav("/quiz");
      }}/>
    </>
  );
}
